export default "__VITE_ASSET__CEXd$jkC__"